import riseUrl from "../assets/logos/risechain.svg";
import symbioticUrl from "../assets/logos/symbiotic.svg";
import hyperbeatUrl from "../assets/logos/hyperbeat.svg";
import etherfiNavUrl from "../assets/logos/etherfi.svg";

export { etherfiNavUrl };

export const LOGO_MAP = {
  rise: riseUrl,
  symbiotic: symbioticUrl,
  hyperbeat: hyperbeatUrl,
};
